module.exports = __webpack_public_path__ + "img/integratedLogo1.e6f652a4.png";